<template>
	<div class="attachments">
		<div v-for="(attachment, index) in attachments" class="row">
			<md-input-container class="col-md-6">
				<label>Kategória</label>
				<md-select v-model="attachments[index].type">
					<md-option v-for="attachmentType in attachmentTypes" :value="attachmentType.value">{{attachmentType.label}}</md-option>
				</md-select>
			</md-input-container>
			<md-input-container class="col-md-3">
				<label>Név</label>
				<md-input v-model="attachment.name"></md-input>
			</md-input-container>
			<md-input-container class="col-md-3">
				<label>Érték</label>
				<md-input v-model="attachment.value"></md-input>
			</md-input-container>
		</div>
		<md-button class="md-primary" v-on:click.native="newAttachment()">Kapcsolati adat hozzáadása</md-button>
	</div>
</template>

<script>
	export default {
		props: ['attachments'],
		data(){
			return {
				attachmentTypes: [{
					label: "E-mail",
					value: "email"
				},{
					label: "Telefon",
					value: "phone"
				},{
					label: "Fájl",
					value: "file"
				},{
					label: "Link",
					value: "link"
				},{
					label: "Egyéb",
					value: "other"
				}]
			}
		},
		methods:{
			newAttachment(){
				this.attachments.push({
					type: this.attachmentTypes[0],
					value: "",
					name: ""
				});
				this.$forceUpdate();
			}
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// AttachmentBlock.vue?140ea3f4